import api from "../api";

export default {
    keyFigures(from, to, events = '') {
        return api.get(`/central/statistics/keyFigures?from=${from}&to=${to}&events=${events}`)
    },
    revenue(from, to, period, events = '') {
        return api.get(`/central/statistics/revenue?from=${from}&to=${to}&period=${period}&events=${events}`)
    },
    ticketCount(from, to, period, events = '') {
        return api.get(`/central/statistics/ticketCount?from=${from}&to=${to}&period=${period}&events=${events}`)
    },
    orderCount(from, to, period, events = '') {
        return api.get(`/central/statistics/orderCount?from=${from}&to=${to}&period=${period}&events=${events}`)
    },
}
